import { useEffect, useState } from 'react';
import {getHubspotTokenApi} from "../services/api";
import { useDispatch } from 'react-redux'; 
import useCustomTheme from '../theme/useCustomTheme';




const PORTAL_ID = process.env.REACT_APP_HUBSPOT_PORTAL_ID; 


 
const useHubspotChat = () => {
  const dispatch = useDispatch();
  const [hubspotData, setHubspotData] = useState(null); // { email, token }
  const [isReady, setIsReady] = useState(false);
  const [theme] = useCustomTheme()

 // key changes: identificationEmail, identificationToken; controlled load sequence
useEffect(() => {
  if (typeof window === "undefined") return;

  // Always prevent auto-load so you can set identification first
  window.hsConversationsSettings = { loadImmediately: false }; // important [web:6]

  // Inject script once
  if (!document.getElementById("hs-script-loader")) {
    const s = document.createElement("script");
    s.id = "hs-script-loader";
    s.async = true;
    s.defer = true;
    s.src = `https://js-na1.hs-scripts.com/${PORTAL_ID}.js`;
    document.body.appendChild(s);
  }

  // API ready queue
  window.hsConversationsOnReady = window.hsConversationsOnReady || [];
  window.hsConversationsOnReady.push(() => setIsReady(true));
}, []);

useEffect(() => {
  // fetch fresh token each session (or cache <12h)
  getHubspotTokenApi()
    .then((res) => {
      if (res?.data?.http_code === 200) {
        const { email, token } = res.data.data; // server must call v3 tokens/create [web:3]
        setHubspotData({ email, token });
      } else console.log(res?.data?.message || "Failed to fetch HubSpot token");
    })
    .catch(() => console.log("Network error fetching HubSpot token"));
}, []);

useEffect(() => {
  if (!isReady || !hubspotData || !window.HubSpotConversations) return;

  const { email, token } = hubspotData;

  // apply identification keys exactly as per docs
  window.hsConversationsSettings = {
    loadImmediately: false,
    identificationEmail: email,        // correct key [web:1]
    identificationToken: token,        // correct key [web:1]
  };

  // ensure a clean mount if chat may have auto-mounted earlier
  window.HubSpotConversations.clear?.({ resetWidget: true }); // recommended for SPA [web:2]
  window.HubSpotConversations.widget.load(); // load after settings applied [web:1][web:6]
}, [isReady, hubspotData]);

};

export const resetHubspotChat = () => {
  if (window.HubSpotConversations) {
    window.HubSpotConversations.clear({ resetWidget: true });
    window.HubSpotConversations.widget.remove();
  }
  
};

export default useHubspotChat;